import './index.css'

const UserInfo = () => (
  <div className="user-info-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/profile-img.png "
      alt="profile"
      className="profile-img"
    />
    <h1 className="profile-head">Wade Warren</h1>
    <p className="profile-para">Software Developer at UK</p>
  </div>
)

export default UserInfo
